// 快递费率设置
import httpClient from "@/services/http/mainServerClient";
import ExpressRateDTO from "@/dto/setting/ExpressRateDTO";
import LogisticsCompany from "@/enum/LogisticsCompany";
import { SettingFormValues } from "@/scenes/setting/ShippingCost/components/SettingForm";


// 获取当前用户的快递费率设置
function getSetting(logisticsCompany: LogisticsCompany): Promise<ExpressRateDTO> {
    return httpClient.get(`/expressRate/${logisticsCompany}`);
}

// 修改地区快递费率
function update(params: SettingFormValues): Promise<void> {
    const { id } = params;
    return httpClient.post(`/expressRate/${id}`, params);
}

// 新增地区快递费率
function add(params: Omit<SettingFormValues, "id">): Promise<ExpressRateDTO> {
    return httpClient.post("/expressRate", params);
}

export default {
    getSetting,
    add,
    update,
};
